/**
 * Mobile Contact Bar
 * Nasconde la barra contatti mobile quando il footer è visibile
 */

class MobileContactBar {
    constructor() {
        this.contactBar = document.getElementById('mobile-contact-bar');
        this.footer = document.getElementById('footer');

        if (!this.contactBar || !this.footer) {
            return;
        }

        // Sposta la barra in body così position:fixed è relativo al viewport e non a un contenitore con transform
        if (this.contactBar.parentNode !== document.body) {
            document.body.appendChild(this.contactBar);
        }

        this.init();
    }

    init() {
        // Usa Intersection Observer per rilevare quando il footer entra in vista
        const observerOptions = {
            root: null, // viewport
            rootMargin: '0px',
            threshold: 0.1 // Trigger quando almeno il 10% del footer è visibile
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Footer è visibile, nascondi la barra
                    this.contactBar.classList.add('is-hidden');
                    // Aggiungi classe al body per rimuovere margin-bottom dallo sticky-block
                    document.body.classList.add('mobile-contact-bar-hidden');
                } else {
                    // Footer non è visibile, mostra la barra
                    this.contactBar.classList.remove('is-hidden');
                    // Rimuovi classe dal body per ripristinare margin-bottom
                    document.body.classList.remove('mobile-contact-bar-hidden');
                }
            });
        }, observerOptions);

        // Osserva il footer
        observer.observe(this.footer);
    }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new MobileContactBar();
    });
} else {
    new MobileContactBar();
}

export default MobileContactBar;

